import React from "react";

function ChartLegend({ color = 'green', description = 'Test' }) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: 10,
      }}
    >
      <div
        style={{
          width: '1.5rem',
          height: '1.5rem',
          backgroundColor: color,
          boxSizing: 'border-box',
          borderRadius: 4,
          borderWidth: '1px 1px 0 0',
        }}
      ></div>
      <div
        style={{
          marginLeft: 4,
        }}
      >{description}</div>
    </div>
  );
}

export default ChartLegend;
